export default __webpack_public_path__ + "static/media/FREIEAUSKUNFT.19d47398.png";